/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_PublisherInputs */

const ja_metadata_publisher = /** @type {(inputs: Metadata_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`株式会社プレイブレーン`)
};

const en_metadata_publisher = /** @type {(inputs: Metadata_PublisherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN`)
};

/**
* | output |
* | --- |
* | "PLAYBRAIN" |
*
* @param {Metadata_PublisherInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const metadata_publisher = /** @type {((inputs?: Metadata_PublisherInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_PublisherInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_metadata_publisher(inputs)
	return en_metadata_publisher(inputs)
});